import styled, { css, createGlobalStyle } from 'styled-components';
import SeH008 from 'dc/SeH008';
import Mod001 from 'dc/Mod001';
import IcoW01 from 'dc/IcoW01';
import TabMen03 from 'dc/TabMen03';

const hideTheChildren = css`
  & > * {
    display: none;
  }
`;

export const GlobalStyle = createGlobalStyle`
  body {
    overflow-y: scroll;
  }
`;

type WrapperProps = {
  $unclickable?: boolean;
};

export const Wrapper = styled.main<WrapperProps>`
  display: flex;
  flex-direction: column;
  background-color: #eceff1;
  pointer-events: ${props => (props.$unclickable ? 'none' : 'auto')};
  transition: padding-top 0.2s ease-out;
  min-height: calc(100vh - 80px);
`;

type StatusBarProps = {
  $show: boolean;
};

export const StatusBar = styled(SeH008)<StatusBarProps>`
  height: ${props => (props.$show ? '36px' : '0')};
  transition: height 0.2s ease-out;
  ${props => !props.$show && hideTheChildren}
`;

export const InnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: #eceff1;
`;

export const Main = styled.main`
  width: 672px;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  margin-left: 32px;
`;

export const Modal = styled(Mod001)`
  * {
    color: #455a64;
  }
  > div {
    border-radius: 5px;
    box-shadow:
      0 15px 20px rgba(0, 0, 0, 0.22),
      0 19px 60px rgba(0, 0, 0, 0.3);
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  width: 100%;
  background: transparent;
`;

export const CloseIcon = styled(IcoW01)`
  cursor: pointer;
  i {
    color: #fff;
  }
`;

export const Image = styled.img`
  height: 140px;
  width: 140px;
`;

export const TabMenu = styled(TabMen03)`
  margin-bottom: 16px;
`;
